<template>
  <div class="container_log">
    <b-container>
      <b-row class="header">
        <b-col>
          <div @click="closeView()" style="cursor:pointer;margin-top:20px;">
            <font-awesome-icon style="font-size:28px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="form_container">
        <div class="col-12" style="text-align:center;color:#2C2A29;font-size:16px;font-weight: 500;">
          ENDEREÇO
        </div>
        <div class="col-10">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'mail-bulk']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @keyup.enter="searchCep()" @blur="validateAndSearch()" :class="{invalidForm: invalidCep}" class="inputFormText" name="cep" placeholder="Digite o CEP " v-model="cep"/>
          <div v-if="invalidCep" class="messageInputError">{{messageErrorCep}}</div>
        </div>
        <div class="col-2" style="position:relative;">
          <div @click="searchCep()" :style="{backgroundColor: getCssColor('primary_bt')}"
            style="position:absolute; top:20px; color:#FFFFFF; cursor:pointer; font-size:18px; line-height:30px; font-weight:500; border-radius:4px; height:30px; width:30px; text-align:center;">
            <font-awesome-icon :icon="['fal', 'search']"/>
          </div>
        </div>
        <div class="col-12">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'road']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateStreet()" :class="{invalidForm: invalidStreet}" class="inputFormText" name="street" placeholder="Rua" v-model="street"/>
          <div v-if="invalidStreet" class="messageInputError">{{messageErrorStreet}}</div>
        </div>

        <div class="col-12">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'home']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateNumber()" :class="{invalidForm: invalidNumber}" class="inputFormText" name="number" placeholder="Número" v-model="number" maxlength="10"/>
          <div v-if="invalidNumber" class="messageInputError">{{messageErrorNumber}}</div>
        </div>

        <div class="col-12">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'home']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text"  class="inputFormText" name="more" placeholder="Complemento" v-model="more"/>
        </div>

        <div class="col-12">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'city']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateVicinity()" :class="{invalidForm: invalidVicinity}" class="inputFormText" name="vicinity" placeholder="Bairro" v-model="vicinity"/>
          <div v-if="invalidVicinity" class="messageInputError">{{messageErrorVicinity}}</div>
        </div>

        <div class="col-12">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'city']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateCity()" :class="{invalidForm: invalidCity}" class="inputFormText" name="city" placeholder="Cidade" v-model="city"/>
          <div v-if="invalidCity" class="messageInputError">{{messageErrorCity}}</div>
        </div>

        <div class="col-12">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'city']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateState()" :class="{invalidForm: invalidState}" class="inputFormText" name="state" placeholder="Estado" v-model="state"/>
          <div v-if="invalidState" class="messageInputError">{{messageErrorState}}</div>
        </div>

        <div class="col-12" style="margin-top:20px;">
          <div @click="getAdressByGoogle()" :style="{backgroundColor: getCssColor('primary_bt')}"
            style="margin-top:20px;color:#FFFFFF; cursor:pointer; font-size:14px; font-weight:500; border-radius:4px; height:40px;line-height:40px;text-align:center;">
            CONTINUAR
          </div>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import colors from '@/mixins/colors'
import UserConn from '@/connection/user'
import LocationConn from '@/connection/location'
import { EventBus } from '@/behaviours/event-bus'

export default {
  name: 'Address',
  data () {
    return {
      cep: null,
      messageErrorCep: 'O campo cep é obrigatório',
      invalidCep: false, 

      street: null,
      messageErrorStreet: 'O campo rua é obrigatório',
      invalidStreet: false,

      number: null,
      messageErrorNumber: 'O campo número é obrigatório',
      invalidNumber: false,

      more: null, 

      vicinity: null, 
      messageErrorVicinity: 'O campo bairro é obrigatório',
      invalidVicinity: false,

      city: null, 
      messageErrorCity: 'O campo cidade é obrigatório',
      invalidCity: false, 

      state: null,
      messageErrorState: 'O campo estado é obrigatório',
      invalidState: false,

      latLong: {lat:0, lng:0},

      country: 'Brasil'
    }
  },
  mixins: [colors],

  methods: {
    continuePurchase() {
      return UserConn.doLogin()
    },

    async validateAndSearch() {
      return this.searchCep()
    },

    async searchCep () {
      if (!this.validateCep()) {
        this.$store.state.showLoading = true
        let result = await LocationConn.getAdressByZipCode(this.cep.replace(/[^0-9]+/g, '').toString())
        if (!result.error) {
          console.log(result)
          let cepAddress = result
          this.street = cepAddress.logradouro
          this.vicinity = cepAddress.bairro
          this.city = cepAddress.localidade
          this.state = cepAddress.uf
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
        this.$store.state.showLoading = false
      }
    },

    closeView () {
      if (this.$store.state.newAddressOrigin === 'cart') {
        this.$router.push({path: '/cart?cover=true'})
      } else if (this.$store.state.newAddressOrigin === 'membership') {
        this.$router.push({path: '/membership_address'})
      } else if (this.$store.state.newAddressOrigin === 'company_list') {
        this.$router.push({path: '/company_list'})
      } else {
        this.$router.push({path: '/profile'})
      }
    },

    async getAdressByGoogle () {
      this.$store.state.showLoading = true
      let address = this.street + ',' + this.number + ' ' + this.vicinity + ' ' + this.city + ' ' + this.cep
      let result = await LocationConn.getAdressByGoogle(address)
      if (result) {
        console.log(result)
        this.latLong = result
      }
      let saveResult = await this.saveAddress()
      this.$store.state.showLoading = false
      if (saveResult) {
        if (this.$store.state.newAddressOrigin === 'cart') {
          this.$router.push({path: '/cart?cover=true'})
        } else if (this.$store.state.newAddressOrigin === 'membership') {
          this.$router.push({path: '/membership_address'})
        } else if (this.$store.state.newAddressOrigin === 'company_list') {
          this.$router.push({path: '/company_list'})
        } else {
          this.$router.push({path: '/profile'})
        }
      }
    },

    async saveAddress () {
      let userId = this.$store.state.user.id
      let result = await UserConn.saveAddress(userId,
        this.street, this.number, this.more, this.vicinity,
        this.city, this.state, this.country, this.cep, this.latLong)
        this.$store.state.checkoutViewSelectedAddress = '0'
      if (result.error) {
        EventBus.$emit('showAlert', 'error', 'Erro ao salvar endereço')
        return false
      } else {
        return true
      }
    },

    validateForm () {
      if (!this.validateCep () &&
          !this.validateStreet() &&
          !this.validateNumber() &&
          !this.validateVicinity() &&
          !this.validateCity() &&
          !this.validateState() 
      ) {
        return true
      } else {
        return false
      }
    },
    validateCep () {
      this.invalidCep = !this.cep || this.cep.length < 8
      return this.invalidCep
    },
    validateStreet () {
      this.invalidStreet = !this.street || this.street.length < 3
      return this.invalidStreet
    },
    validateNumber () {
      this.invalidNumber = !this.number || this.number.length < 1
      return this.invalidNumber
    },
    validateVicinity () {
      this.invalidVicinity = !this.vicinity || this.vicinity.length < 2
      return  this.invalidVicinity
    },
    validateCity () {
      this.invalidCity = !this.city || this.city.length < 3
      return this.invalidCity
    },
    validateState () {
      this.invalidState = !this.state || this.state.length < 2
      return this.invalidState
    }

  }
}
</script>

<style lang="scss" scoped>

.form_container {
  position:relative;
  width: 100%;
  max-width:434px;
  line-height: 20px;
  margin: 0px auto;
}
.container_log {
  width:100vw;
  // max-width: 1330px;
  min-height: 100vh;
  background-color: #FFFFFF;
}
.header{
  // max-width: 1330px;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  height: 46px;
  text-align:right;
  top: 10px;
}



.inputFormText {
    width: 100%;
    font-size:16px;
    height:40px;
    padding-left:35px;
    color: #2C2A29;
    background-color: transparent;
    border:0px;
    border-bottom: 1px solid #2C2A29;
  }
.imgInputIcon {
    position:relative;
    left:5px;
    top:30px;
    font-size:16px;
  }

  .imgSelectIcon {
    font-size:16px;
    margin-left:5px;
  }

  input::placeholder {
    font-size:16px;
    //color: #2C2A29;
  }

  input:focus {
    outline: none;
    border:0px;
    border-bottom: 1px solid #5E2B8B;
  }

  .messageInputError {
  color: rgb(255, 88, 88);
  font-size:12px;
  padding:4px;
}

.invalidForm {
  border-bottom: 1px solid rgb(255, 88, 88)!important;
}
</style>
